















































































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'PrivacyPolicyPageForMens'
})
export default class PrivacyPolicyPageForMens extends Vue {

}
